(function ($) {

    let hero = $(".hero-items");
    let length = $(".hero-items li").length;
    let firstitem = $(".hero-items li:last-child").clone().addClass('first-item');
    let lastitem = $(".hero-items li:first-child").clone().addClass('last-item');
    let nav = $(".fixed .nav");

    hero.prepend(firstitem);
    hero.append(lastitem);

    let duration = 7000;
    let i = 1;
    let position = 0;

    function start() {

        let herocontent;
        
        if(i == -1){
            herocontent = $(".hero-items").find('li.first-item').find('.hero-content');
        } else if (i == length){
            herocontent = $(".hero-items").find('li.last-item').find('.hero-content');
        } else {
            herocontent = $(".hero-items").children('li').not('.first-item, .last-item').eq(i).find('.hero-content');
        }

        if (i <= length) {

            position = -100 * i;

            herocontent.removeClass('animate');

            herocontent
                .find('h1,p,a')
                .css({
                    'margin-left': '50%',
                    'opacity': '0'
                })
                .delay()
                .queue(function (next) {
                    herocontent.addClass('animate')
                        .find('h1,p,a')
                        .css({
                            'margin-left': '0%',
                            'opacity': '1'
                        });
                    next();
                });

            hero.css('left', position + '%').on('transitionend', function (e) {

                let property = e.originalEvent.propertyName;

                if (property == "left") {

                    if (i > length) {
                        position = 0;
                        hero.removeClass('animate');
                        hero.css('left', position+'%').delay().queue(function (next) {
                            hero.addClass('animate');
                            next();
                        });
                        i = 1;
                        nav.find('a').removeClass('active');
                        nav.find("a:nth-child(" + i + ")").addClass("active");
                        

                    } else if(i == 0) {
                        position = -100 * (length-1);
                        hero.removeClass('animate');;
                        hero.css('left', position+'%').delay().queue(function (next) {
                            hero.addClass('animate');
                            next();
                        });
                        i=length;
                        nav.find('a').removeClass('active');
                        nav.find("a:nth-child(" + length + ")").addClass("active");

                    } else {

                        nav.find('a').removeClass('active');
                        nav.find("a:nth-child(" + i + ")").addClass("active");
                    }
                }

            });

            i++;

        }

    }

    $(document).ready(function () {

        let startInterval = setInterval(function () { start(); }, duration);
        let initx;
        let x;

        hero.on('touchstart', function (e) {

            clearInterval(startInterval);

            initx = e.touches[0].pageX;
            x = e.touches[0].pageX;


        });

        hero.on('touchmove', function (e) {
            x = e.touches[0].pageX;
        });


        hero.on('touchend', function () {
            if (initx !== undefined && x !== undefined) {
                if (initx > x) {
                    start();
                    startInterval = setInterval(function () { start(); }, duration);
                } else if (initx < x) {
                    i -= 2;
                    start();
                    startInterval = setInterval(function () { start(); }, duration);
                }
            }
        });

        nav.find('a').click(function (e) {

            e.preventDefault();

            clearInterval(startInterval);

            if (i == length && $(this).attr('data-i') == 0) {
                i = length;
            } else if (i == 1 && $(this).attr('data-i') == length - 1) {
                i = -1;
            } else {
                i = $(this).attr('data-i');
            }

            start();
            startInterval = setInterval(function () { start(); }, duration);

        });

    });
})(jQuery)